export default class ClientVehicle {
    clientId: number
    vacancyId: number
    plate: String
    driverName: String
    modelYear: String
    color: String
    model: String
    
    constructor(clientId, vacancyId, plate, driverName, modelYear, color, model) {
        this.clientId = clientId
        this.vacancyId = vacancyId
        this.plate = plate
        this.driverName = driverName
        this.modelYear = modelYear
        this.color = color
        this.model = model
    }
}